<template>
  <div>
    <div id="header" class="header_with_bg" style="z-index: -1;"></div>
   <div class="content">
    <p style="text-align: center; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style="font-size: 24px; font-family: 微软雅黑, &quot;Microsoft YaHei&quot;;"><strong><span style="font-size: 24px;">上海复歌信息科技有限公司</span></strong></span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style="font-family: 等线; text-indent: 2em;">复歌成立于2009年，利用技术和数据打造有价值的产品，帮助营销领域的组织和个人更高效 更愉快地演进。</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">在过去的十二年里，有超过</span>300家一线品牌和agency，信任并使用了复歌的产品。包括 联合利华、欧莱雅、LVMH、阳狮、电通、WPP。更重要的是，复歌正在为超过30000名充满才华的自由从业者提供服务。</span>
</p>
<h4 style="text-align: left; text-indent: 2em;">
    <span style="font-size: 16px;"><strong>主要业务</strong></span>
</h4>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">为广告营销行业内的广告代理商以及品牌方提供合适的</span>freelancer解决方案、开发完成广告营销行业推广的优化平台等</span>
</p>
<h4 style="text-align: left; text-indent: 2em;">
    <span style="font-size: 16px;"><strong>发展历程</strong></span><br/>
</h4>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px">2009年创立于复旦大学科技园</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px">2009-2014年研发了针对国内搜索引擎市场的SEM工具，服务于各美妆品牌主以及广告公司。</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px">2015-2019年随着DSP市场的迅速发展，研发了Rimix trading dask平台，并顺利获得2000w融资。</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">同期为联合利华提供了</span>UniSever marketing ERP系统，也凭借该系统，登上了戛纳广告金奖的舞台。</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px">2019至今，开发完成广告营销行业的freelancer直聘平台——好快活小程序</span>
</p>
<h4 style="text-align: left; text-indent: 2em;">
    <span style="font-size: 16px;">关于团队</span><strong> </strong>
</h4>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style="font-size: 14px; font-family: 等线;">复歌是一个年轻的团队，工作上，专业、注重细节、拥抱创新、快速试错。协作中，开放、坦诚、包容、还有一点点举重若轻的幽默感。</span>
</p>
<h4 style="text-align: left; text-indent: 2em;">
    <span style="font-size: 16px;">公司团队高管<strong> </strong></span>
</h4>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px">1、郭为：CEO </span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">复旦大学</span>&nbsp;<span style="font-family:等线">物理学</span> <span style="font-family:等线">和</span> <span style="font-family:等线">经济学</span></span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px">College of William &amp; Mary（公立常春藤） GPA 3.85/4.0 全额奖学金</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px">ZS Associates 波士顿办公室 2020全球 营销类consulting公司 排名第8</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px">2021 Tech MVP by CampaignAsia (中国区2人）</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">戛纳国际创意节</span>&nbsp;<span style="font-family:等线">技术创新专场</span> <span style="font-family:等线">演讲嘉宾</span></span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px">2、张薇：副总裁</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">东京大学</span>&nbsp;<span style="font-family:等线">金融</span> <span style="font-family:等线">全额奖学金</span></span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">埃森哲</span>&nbsp;Accenture 东京办公室</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">复歌科技</span>&nbsp;<span style="font-family:等线">亚洲营销女性二十人</span></span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px">3、朱奇：副总裁</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">上海大学</span>&nbsp;<span style="font-family:等线">广告学</span></span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px">CCTV 和 百度 KA客户销售 top sales </span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">银科控股</span>&nbsp;CMO 管理营销预算超8亿/年</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px">4、刘魏东：产品总监</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">万能页创始人，服务于</span>20w+小微企业用户</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">上海一铺联合创始人兼</span>CTO，产品主要负责人，获得Intel千万A轮融资</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px">5、王元：技术总监</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">东南大学</span>&nbsp;<span style="font-family:等线">信息工程</span> <span style="font-family:等线">移动通信国家重点实验室</span></span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">谢菲尔德大学</span>&nbsp;<span style="font-family:等线">信息系统</span></span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px">GitHub中国区关注度 top100</span>
</p>
<h4 style="text-align: left; text-indent: 2em;">
    <span style="font-size: 16px;">核心产品</span>
</h4>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style="font-size: 14px; font-family: 等线;">好快活——freelancer直聘平台</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">好快活</span> <span style="font-family:等线">是一个营销人才平台，帮助企业客户连接并匹配充满才华的营销人才。已经有超过</span>400家品牌方和agency，在使用好快活寻找全职和freelancer人才。同时有超过30000名一线营销人才，在好快活塑造个人IP，分享自身才华。</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">拥有超过玩人的广告行业垂直社群，以小程序</span>+社群结合的运营模式展开，针对行业内的用人方和个人方共同提供服务。解决双方痛点，实现共赢</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">好快活</span>&nbsp;<span style="font-family:等线">为企业提供的价值：</span></span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">找</span>free：直接触达 30000+ 一线营销人才</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style="font-size: 14px; font-family: 等线;">找全职：智能匹配，专业猎头团队完成人才跟进和推荐</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">人才的统一签约和代付，节约</span>90%以上流程和税费成本</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">好快活</span>&nbsp;<span style="font-family:等线">为人才提供的价值：</span></span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">个性化推荐</span>&nbsp;<span style="font-family:等线">一线全职职位</span> <span style="font-family:等线">和</span> <span style="font-family:等线">兼职项目需求</span></span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style="font-size: 14px; font-family: 等线;">一对一项目经理，代谈需求、签约和收款</span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px"><span style="font-family:等线">个人</span>IP的塑造和推广&quot;</span>
</p>
<h4 style="text-align: left; text-indent: 2em;">
    <span style="font-size: 16px;">其他产品</span>
</h4>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px">Bid Agent<span style="font-family:等线">，是一款专为中国市场设计的搜索引擎优化管理工具，支持</span>5大搜索引擎。没有人比我们更了解中国的搜索引擎。帮助200+品牌管理10w+关键词和每年10亿投放预算<span style="font-family:等线">。</span></span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px">Rimix<span style="font-family:等线">，获得</span>2000w融资的trading desk，整合150+流量和数据源 实现70ms实时竞价<span style="font-family:等线">。</span></span>
</p>
<p style="text-align: left; line-height: 1.75em; margin-bottom: 15px; text-indent: 2em;">
    <span style=";font-family:等线;font-size:14px">UniService<span style="font-family:等线">，被戛纳创意节认可的</span>Marketing ERP，每年管理5000+项目和数十亿营销预算</span>
</p>
   </div>
  </div>
</template>

<script>
export default {
  name: "FUGEIndex",

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style scoped>
.content {
  /* max-width: 980px; */
  margin: auto;
  padding: 100px 16px 0 16px;
  width: calc(100% - 32px);
}
</style>
